const basemapApiKey = "lRjM8p00Dkt0fhMtGySPOEPGF20nLV8i";

const backendUrl = process.env.NODE_ENV === "development" ? "http://localhost:8000" : "";

const config = {
    backendUrl: `${window.location.protocol}//${window.location.hostname}${window.location.port ? (':' + window.location.port) : ''}`,
    geoserverUrl: process.env.NODE_ENV === "development" ? "http://localhost:8000" : `${window.location.protocol}//${window.location.hostname}${window.location.port ? (':' + window.location.port) : ''}`,
    hostUrl: `${window.location.protocol}//${window.location.hostname}${window.location.port ? (':' + window.location.port) : ''}`,
    api: {
        getUser: `${backendUrl}/api/user/`,
        getJobs: `${backendUrl}/api/jobs/`,
        getNews: `${backendUrl}/api/news/`,
        updateProcess: `${backendUrl}/api/process/update/`,
        getProcess: `${backendUrl}/api/process/`,
        copyPdfFiles: `${backendUrl}/api/pdf/all/`,
        publishLayer: `${backendUrl}/api/layer/publish/`,
        uploadFile: `${backendUrl}/api/upload/`,
        getData: `${backendUrl}/api/data/`,
        getDetails: `${backendUrl}/api/details/`,
        signIn: `${backendUrl}/api/sign/in/`,
        signOut: `${backendUrl}/api/sign/out/`,
        copyFile: `${backendUrl}/api/copyfile/`,
        startProcess: `${backendUrl}/api/start/`,
    },
    basemapUrl: `https://mapservices-{a-c}.navici.com/basemaps/gwc/service/wmts?apikey=${basemapApiKey}`,
};
export default config;



// WEBPACK FOOTER //
// ./src/config/index.js